import { useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalState';
import { listenRetrospectiveChange } from '../../services/retrospectives';

function useListenRetrospectiveChange(handleErrorPage) {
  const { currentRetrospectiveId, user, onLoading, onLoadRetrospective } =
    useContext(GlobalContext);

  useEffect(() => {
    const userHasPermission = (data) =>
      user.id === data.facilitator || data.participants.includes(user.id);
    const unsubscribe = listenRetrospectiveChange(
      currentRetrospectiveId,
      (document_) => {
        if (!document_.exists || !userHasPermission(document_.data())) {
          handleErrorPage();
        } else {
          onLoadRetrospective({ id: document_.id, ...document_.data() });
        }
        onLoading(false);
      },
      handleErrorPage
    );

    return () => {
      unsubscribe();
      onLoading(false);
    };
  }, [
    currentRetrospectiveId,
    handleErrorPage,
    onLoadRetrospective,
    onLoading,
    user.id,
  ]);
}

export default useListenRetrospectiveChange;
